import React, {useContext, useEffect, useState } from "react"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { spacing } from "@izettle/otto"
import { Loader, LoaderSize } from "@izettle/react"
import { AuthContext } from "@izettle/react-spa"

import { Error } from '@/components/error'
import { useSetPageTitle } from "@/components/page-title"
import { baseUrl } from "@/constants"
import { getRequirements } from "@/services"

import { Requirement } from "../generic-document-upload"

import { InstructionsList } from "./instructions-list"

const PageContainer = styled.div`
  margin: ${spacing.small};
`

export const InstructionsView: React.FC = () => {
  const { text } = useLocalization()
  const { setPageTitle } = useSetPageTitle()
  const { getToken } = useContext(AuthContext)

  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isError, setIsError] = useState<boolean>(false)
  const [requirements, setRequirements] = useState<Requirement[] | null>(null)

  useEffect(() => {
    setPageTitle(text("GENERIC_DOC_UPLOAD"))
  }, [])

  const fetchRequirements = async () => {
    try {
      const requirementsFromApi: any = await getRequirements(getToken)
      setRequirements(requirementsFromApi.requirements)
    } catch {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    void fetchRequirements()
  }, [])

  if (isLoading) {
    return <Loader fullscreen size={LoaderSize.Large} />
  }

  if (isError || !requirements) {
    return <Error cancelUrl={baseUrl} />
  }

  return (
    <PageContainer>
      <InstructionsList requirements={requirements} />
    </PageContainer>
  )
}
